<div class="app-safe-area">
    <app-training-mode-banner></app-training-mode-banner>
    <router-outlet></router-outlet>
    <app-call-card></app-call-card>
</div>